module.exports = __webpack_public_path__ + "img/right-to-bracket.b0ddc30b.svg";